import { RootStore } from "./RootStore";

export const store = new RootStore();
